import noticeApiList from "@/service/basic/noticeApiList";
import { api } from "@/service/api";
const myhost = echarthostname;

// 开发：http://dev.diablo.ruigushop.com
//   测试：http://test-diablo.ruigushop.com
//   生成：http://diablo.ruigushop.com

// 获取未读消息
export function getNotice(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .get(`${myhost}${noticeApiList.getNotice}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 获取消息详情
export function getNoticeDetail(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .get(`${myhost}${noticeApiList.getDetail}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 确认消息
export function confirmNotice(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .post(`${myhost}${noticeApiList.confirmNotice}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/models/noticeModel.js